<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
        <path d="M25 10L15 20L25 30" :stroke="color" stroke-opacity="0.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M15 10L5 20L15 30" :stroke="color" stroke-opacity="0.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
</template>

<script>

export default {
    name: 'double-angle-left-svg',
    props: {
        color: {
            type: String,
            default: '#000000'
        }
    }
}
</script>

<style lang="scss" scoped></style>